import React from "react";
import { twMerge } from "tailwind-merge";
import { StepperProps } from "./StepperTypes";

const Stepper: React.FC<StepperProps> = ({
  steps,
  currentStep,
  isLoading = false,
  onStepChange,
  classes = {
    stepCircle:
      "w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 text-xs sm:text-sm md:text-base rounded-full flex items-center justify-center text-white font-bold cursor-pointer transition-all duration-300",
    connectorLine: "w-full h-[0.15rem] absolute top-[1.125rem] bg",
    stepLabel:
      "mt-2 sm:mt-4 text-[10px] sm:text-xs md:text-sm font-medium text-center",
    contentContainer: "bg-white shadow-md",
    previousButton: "px-4 py-2 disabled:opacity-50 transition",
    nextButton: "px-4 py-2 disabled:opacity-50 transition",
    spinner: "animate-spin h-12 w-12 border-t-4",
  },
  headerComponent,
}) => {
  return (
    <div className="w-full flex flex-col items-center px-4">
      {/* Tout le contenu dans un conteneur max-w-7xl centré */}
      <div className="w-full max-w-7xl">
        {/* Hotel Info Header optionnel */}
        {headerComponent && headerComponent}

        {/* Stepper Content */}
        <div className="p-6">
          {/* Stepper Header */}
          <div className="relative">
            <div
              className={twMerge(classes.connectorLine, `bg-[#DCCEBB] `)}
              style={{ left: "0", right: "0" }}
            />
            <div className="w-full">
              <div className="flex relative z-10 w-full">
                {steps.map((step, index) => {
                  // Determine class based on step position
                  let alignmentClass = "items-center text-center";
                  if (index === 0) alignmentClass = "items-start text-start";
                  else if (index === steps.length - 1)
                    alignmentClass = "items-end text-end";

                  return (
                    <div
                      key={index}
                      className={twMerge(
                        "flex-1 flex flex-col",
                        alignmentClass
                      )}
                    >
                      <div
                        className={twMerge(
                          "w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 text-xs sm:text-sm md:text-base rounded-full flex items-center justify-center text-white font-bold cursor-pointer transition-all duration-300",
                          index < currentStep
                            ? `bg-[#aa8453]`
                            : index === currentStep
                            ? `bg-[#222] hover:bg-[#222]`
                            : `bg-[#DCCEBB]`,
                          isLoading && index === currentStep
                            ? "animate-pulse"
                            : ""
                        )}
                        onClick={() => onStepChange(index)}
                      >
                        {index < currentStep ? (
                          <svg
                            className="w-3 h-3 sm:w-4 sm:h-4 md:w-5 md:h-5"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                        ) : (
                          index + 1
                        )}
                      </div>
                      <span
                        className={twMerge(
                          "mt-1 sm:mt-2 text-[10px] sm:text-xs md:text-sm font-medium leading-tight break-words whitespace-normal",
                          index === currentStep
                            ? `text-[#4b5563]`
                            : "text-black"
                        )}
                      >
                        {step.label}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Step Content */}
          <div className="relative mt-8">
            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div
                  className={twMerge(classes.spinner, `border-[#aa8453]`)}
                ></div>
              </div>
            ) : (
              <div className={twMerge(classes.contentContainer)}>
                {steps[currentStep]?.component}
              </div>
            )}
          </div>

          {/* Navigation Buttons
          
              <div className="flex justify-between mt-6">
            <button
              onClick={() => onStepChange(currentStep - 1)}
              disabled={currentStep === 0 || isLoading}
              className={twMerge(
                classes.previousButton,
                `bg-[#aa8453] text-white hover:bg-[${colors.buttonHoverBg}]`
              )}
            >
              Previous
            </button>
            <button
              onClick={() => onStepChange(currentStep + 1)}
              disabled={currentStep === steps.length - 1 || isLoading}
              className={twMerge(
                classes.nextButton,
                `bg-[#aa8453] text-white hover:bg-[${colors.buttonHoverBg}]`
              )}
            >
              Next
            </button>
          </div>
          */}
        </div>
      </div>
    </div>
  );
};

export default Stepper;
